(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = selector => root.querySelector(selector);
    const labels = JSON.parse($('[data-pse-labels]').textContent);
    const header = document.querySelector('header-component');
    const updateOffset = () => root.style.setProperty('--pse-header-offset', `${header ? Math.ceil(header.getBoundingClientRect().height) : 0}px`);
    updateOffset();
    const headerObserver = new ResizeObserver(updateOffset);
    if (header) headerObserver.observe(header);
    const mainImage = $('.pse-main-image');
    const thumbs = [...root.querySelectorAll('[data-hero-image]')];
    const selector = $('[data-variant-select]');
    const form = $('.pse-product-form');
    const quantity = form.querySelector('[name="quantity"]');
    const dialog = $('[data-image-dialog]');
    const contact = $('[data-contact-dialog]');
    const nativeGallery = $('[data-native-gallery]');
    let mediaController;
    async function updateNativeGallery(variantId) {
      if (!nativeGallery) return;
      mediaController?.abort();
      const controller = new AbortController();mediaController = controller;
      nativeGallery.setAttribute('aria-busy','true');$('[data-gallery-error]').hidden = true;
      try {
        const url = new URL(location.href);url.searchParams.set('variant',variantId);url.searchParams.set('section_id',root.dataset.sectionId);url.hash = '';
        const response = await fetch(url,{signal:controller.signal});
        if (!response.ok) throw new Error('Media unavailable');
        const page = new DOMParser().parseFromString(await response.text(),'text/html');
        const replacement = page.querySelector('[data-native-gallery]');
        if (!replacement?.querySelector('media-gallery')) throw new Error('Media missing');
        if (controller.signal.aborted) return;
        nativeGallery.replaceChildren(...replacement.childNodes);
      } catch (error) {
        if (error.name !== 'AbortError') $('[data-gallery-error]').hidden = false;
      } finally {
        if (mediaController === controller) nativeGallery.removeAttribute('aria-busy');
      }
    }
    const colorButtons = [];
    if (selector.dataset.singleOption === 'true' && /^(color|colour|颜色)$/i.test(selector.dataset.optionName)) {
      for (const option of selector.options) {
        const button = document.createElement('button');button.type = 'button';
        const color = option.dataset.title.replace(/\s+/g,'').toLowerCase();
        const validColor = CSS.supports('color', color);
        button.className = validColor ? 'swatch' : 'variant-chip';
        if (validColor) button.style.setProperty('--swatch', color); else button.textContent = option.dataset.title;
        button.setAttribute('aria-label', option.textContent);button.title = option.textContent;
        button.dataset.variant = option.value;
        button.addEventListener('click', () => {selector.value = option.value;selector.dispatchEvent(new Event('change',{bubbles:true}));});
        $('[data-variant-swatches]').append(button);colorButtons.push(button);
      }
      selector.hidden = true;$('.pse-variant-label').hidden = true;$('[data-color-options]').hidden = false;
    }
    let zoomItems = [], zoomIndex = 0;
    function setImage(src, id) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      const index = thumbs.findIndex(button => button.dataset.imageId === id);
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageId === id)));
      $('[data-image-counter]').textContent = `${index < 0 ? 1 : index + 1} / ${thumbs.length}`;
    }
    thumbs.forEach(button => button.addEventListener('click', () => setImage(button.dataset.heroImage, button.dataset.imageId)));
    function variantChanged(updateURL) {
      const option = selector.selectedOptions[0];
      if (!option) return;
      $('[data-price]').textContent = option.dataset.price;
      const button = $('[data-add-button]');
      button.disabled = option.dataset.available !== 'true';
      button.replaceChildren(document.createTextNode(button.disabled ? labels.sold : labels.add));
      const arrow = document.createElement('span');arrow.textContent = '↗';button.append(arrow);
      setImage(option.dataset.image, option.dataset.imageId);
      $('[data-contact-variant]').value = option.textContent.trim();
      quantity.min = option.dataset.min || '1';quantity.step = option.dataset.step || '1';quantity.max = option.dataset.max || '';
      const min = Number(quantity.min), max = quantity.max ? Number(quantity.max) : Infinity;
      quantity.value = Math.min(max, Math.max(min, Number(quantity.value) || min));
      colorButtons.forEach(item => item.setAttribute('aria-pressed', String(item.dataset.variant === option.value)));
      if (colorButtons.length) $('[data-color-label]').textContent = `${selector.dataset.optionName} — ${option.dataset.title}`;
      if (updateURL) {
        const url = new URL(location.href);url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        updateNativeGallery(option.value);
      }
    }
    selector.addEventListener('change', () => variantChanged(true));
    root.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
      const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
      const max = quantity.max ? Number(quantity.max) : Infinity;
      quantity.value = Math.min(max, Math.max(min, (Number(quantity.value) || min) + Number(button.dataset.qty) * step));
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    function renderZoom() {
      $('[data-zoom-image]').src = zoomItems[zoomIndex];
      $('[data-zoom-count]').textContent = `${zoomIndex + 1} / ${zoomItems.length}`;
    }
    function openZoom(items, index) {
      if (!items.length) return;
      zoomItems = items;zoomIndex = Math.max(index, 0);renderZoom();dialog.showModal();
    }
    root.querySelectorAll('[data-zoom-main]').forEach(button => button.addEventListener('click', () => {
      openZoom(thumbs.map(item => item.dataset.heroImage), thumbs.findIndex(item => item.getAttribute('aria-pressed') === 'true'));
    }));
    const gallery = [...root.querySelectorAll('[data-gallery-image]')];
    gallery.forEach((button,index) => button.addEventListener('click', () => openZoom(gallery.map(item => item.dataset.galleryImage),index)));
    const stepZoom = delta => {
      if (!zoomItems.length) return;
      zoomIndex = (zoomIndex + delta + zoomItems.length) % zoomItems.length;renderZoom();
    };
    root.querySelectorAll('[data-zoom-step]').forEach(button => button.addEventListener('click', () => stepZoom(Number(button.dataset.zoomStep))));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') stepZoom(1);
      if (event.key === 'ArrowLeft') stepZoom(-1);
    });
    root.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    root.querySelectorAll('dialog').forEach(item => item.addEventListener('click', event => {if (event.target === item) {const r=item.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)item.close();}}));
    root.querySelectorAll('[data-contact]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const field = contact.querySelector('textarea');
      if (!field.value.trim() && link.dataset.subject) field.value = `${link.dataset.subject}\n\n`;
      contact.showModal();
    }));
    root.querySelectorAll('a[href^="#"]:not([data-contact])').forEach(link => link.addEventListener('click', event => {
      const target = $(link.getAttribute('href'));
      if (!target || target.hidden) return;
      event.preventDefault();event.stopPropagation();
      const url = new URL(location.href);url.hash = target.id;history.replaceState({}, '', url);
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
    }));
    if (contact.querySelector('[data-contact-result]')) contact.showModal();
    const description = $('#product-description');
    if (window.renderProductDescription) window.renderProductDescription({root:description,section:$('#specifications'),title:$('#description-title'),searchTools:$('#spec-tools'),searchInput:$('#spec-search'),emptyMessage:$('#spec-empty'),html:description.innerHTML,productTitle:$('#pse-product-title').textContent,labels});
    const nav = $('.section-nav');
    nav.querySelectorAll('a[href^="#"]').forEach(link => {
      const target = $(link.getAttribute('href'));
      if (!target || target.hidden) link.hidden = true;
    });
    const targets = [...nav.querySelectorAll('a[href^="#"]')].filter(link => !link.hidden && !link.classList.contains('nav-buy'));
    const observer = new IntersectionObserver(entries => {
      entries.filter(entry => entry.isIntersecting).forEach(entry => targets.forEach(link => link.classList.toggle('active', link.getAttribute('href') === `#${entry.target.id}`)));
    }, {rootMargin:'-15% 0px -65% 0px'});
    targets.forEach(link => {const target=$(link.getAttribute('href'));if(target)observer.observe(target);});
    root.pseCleanup = () => {observer.disconnect();headerObserver.disconnect();mediaController?.abort();};
    variantChanged(false);
  };
  document.querySelectorAll('[data-pse-detail]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pse-detail]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-pse-detail]').forEach(root => root.pseCleanup?.()));
})();
